<div class="modal-header" *ngIf="!hideHeader">
    <h4 class="modal-title" id="modal-basic-title">
        <ng-content select="[header]"></ng-content>
        <div>
            <button type= button [tabindex]="-1" class="close"
                aria-label="close" (click)="closeModal()" *ngIf="!hideCross">
                <span aria-hidden="true" class="close-button">&times;</span>
            </button>
        </div>
    </h4>
</div>
<div class="modal-header" *ngIf="hideHeader">
        <div header class="w-100 d-flex justify-content-between align-items-center">
            <!-- Title -->
            <h4 id="modal-basic-title" class="modal-title mb-0">
                    {{HeaderText}}
            </h4>
            <!-- Right Side Icons -->
            <div class="d-flex align-items-center">
            <!-- Help Icon -->
            <app-user-guide-icon class="user_guide"  [ActiveTabId]="ActiveTabId"> </app-user-guide-icon>
            <!-- Close Button -->
           <button type= button [tabindex]="-1" class="close"
                aria-label="close" (click)="closeModal()">
                <span aria-hidden="true" class="close-button">&times;</span>
            </button>
            </div>
        </div>
</div>
<div class="modal-body" [ngClass]=" applyCustmCSS? 'modal--body_height max--height_55' : ''">
    <div class="eprx--block__content">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
<div class="modal-footer" *ngIf="!hideFooter">
    <ng-content select="[footer]"></ng-content>
</div>
